import React from 'react';
import ManageEntityList from './ManageEntityList';
import ClientDepartmentList from './ClientDepartmentList';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import { useHeight } from '../../Services/HeightContext';
import ClientModal from '../Models/ClientModal';
import ClientStaffList from './ClientStaffList';
import entities from '../../utils/entities';
import ClientEditor from '../TabbedEntity/ClientEditor';

const ClientList = ({ route }) => {
    const { clientId, clientList } = useParams();
    const [height] = useHeight();
    return <React.Fragment><ManageEntityList route={route + '/' + clientList} parentHeight={height} id={clientId} entity={entities.client} />
        <Switch>
            <Route path={route + '/' + clientList + '/:clientId/:clientAction/:list/:activeKey'}
                render={({ match }) => <ClientModal entity={entities.client} route={route + '/Clients'} itemParam='clientId'><ClientEditor route={route + '/Clients'} /></ClientModal>
                } />
            <Route path={route + '/' + clientList + '/:clientId/:clientAction/:list'}
                render={({ match }) => <ClientModal entity={entities.client} route={route + '/Clients'} itemParam='clientId'><ClientEditor route={route + '/Clients'} /></ClientModal>
                } />
            <Route path={route + '/' + clientList + '/:clientId/:clientAction'}
                render={({ match }) => <ClientModal entity={entities.client} route={route + '/Clients'} itemParam='clientId'><ClientEditor route={route + '/Clients'} /></ClientModal>
                } />
            <Route path={route + '/' + clientList + '/:clientId'}
                render={({ match }) => <ClientModal entity={entities.client} route={route + '/Clients'} itemParam='clientId'><ClientEditor route={route + '/Clients'} /></ClientModal>
                } />
        </Switch>
    </React.Fragment>
};
const ManageClients = ({ route = '/manageClients' }) => {
    const { clientId, clientList } = useParams();
    let history = useHistory();
    const [height] = useHeight();

    const setActiveTab = (tab) => {
        if (clientList !== tab) {
            history.push(route + '/' + tab);
        }
    }

    return <React.Fragment><Tabs activeKey={clientList} onSelect={setActiveTab}>
        <Tab key='Clients' eventKey='Clients' title='Clients'>
            {clientList === 'Clients' ? <ClientList route={route} /> : null}
        </Tab>
        <Tab key='Departments' eventKey='Departments' title='Departments'>
            {clientList === 'Departments' ? <ClientDepartmentList hideActions admin route={route + '/' + clientList} parentHeight={height} id={clientId} /> : null}
        </Tab>
        <Tab key='Staff' eventKey='Staff' title='Staff'>
            {clientList === 'Staff' ? <ClientStaffList hideActions admin route={route + '/Staff'} /> : null}
        </Tab>



    </Tabs>
    </React.Fragment>;
}
export default ManageClients;

